import { setGroupFilters } from './../actions/set-group-filters.actions';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PaginationState } from '@shared/models/pagination-state';
import { Sorting } from '@shared/models/sorting';
import { LoadingState } from '@shared/types/loading-state';
import { Observable } from 'rxjs';
import { loadCustomers } from '../actions/load-customers.actions';
import { loadCustomer } from '../actions/load-customer.actions';
import * as fromCustomers from '../reducers/customers.reducer';
import { selectAddCustomerParentGroup } from '../actions/select-add-customer-parent-group.actions';
import { createCustomer } from '../actions/create-customer.actions';
import { updateCustomer } from '../actions/update-customer.actions';
import { GroupFilters } from '@shared/models/group-filters';
import { RenewalAsAService } from '@shared/models/renewal-as-a-service';
import { Group } from '@shared/models/group';
import { selectCustomerForUpdate } from '../actions/select-customer-for-update.actions';
import { selectAllCustomersForUpdate } from '../actions/select-all-customers-for-update.actions';
import { batchUpdateCustomers } from '../actions/batch-update-customers.actions';
import { updateExternalCustomerSubscriptions } from '../actions/update-external-customer-subscriptions.actions';
@Injectable({
  providedIn: 'root',
})
export class CustomersService {
  constructor(private store: Store) {}

  loadCustomers(paginationState: PaginationState, sorting: Sorting, filters: any) {
    this.store.dispatch(
      loadCustomers({
        paginationState: paginationState,
        sorting: sorting,
        filters: filters,
      }),
    );
  }

  loadCustomer(groupId: string) {
    this.store.dispatch(loadCustomer({ groupId: groupId }));
  }

  createCustomer(group: Partial<Group>, leadId?: number) {
    this.store.dispatch(createCustomer({ group, leadId }));
  }

  updateCustomer(group: Partial<Group>) {
    this.store.dispatch(updateCustomer({ group: group }));
  }

  batchUpdateCustomers(group: Partial<Group>) {
    this.store.dispatch(batchUpdateCustomers({ group: group }));
  }

  selectAddCustomerParentGroup(group: Partial<Group>) {
    this.store.dispatch(selectAddCustomerParentGroup({ group }));
  }

  setGroupFilters(filters: GroupFilters) {
    this.store.dispatch(setGroupFilters({ filters: filters }));
  }

  selectCustomerForUpdate(checked: boolean, groupId: string) {
    this.store.dispatch(selectCustomerForUpdate({ checked: checked, groupId: groupId }));
  }

  selectAllCustomersForUpdate(checked: boolean, allCustomers: boolean) {
    this.store.dispatch(selectAllCustomersForUpdate({ checked: checked, allCustomers: allCustomers }));
  }

  updateExternalCustomerSubscriptions(groupId: string) {
    this.store.dispatch(updateExternalCustomerSubscriptions({ groupId }));
  }

  getCustomerById(groupId: string): Observable<Group | undefined> {
    return this.store.select(fromCustomers.selectCustomerById(groupId));
  }

  getRenewalAsAServiceByCustomerId(groupId: string): Observable<RenewalAsAService | undefined> {
    return this.store.select(fromCustomers.selectRenewalAsAServiceByCustomerId(groupId));
  }

  getCustomersLoading(): Observable<LoadingState> {
    return this.store.select(fromCustomers.selectCustomersLoadingState);
  }

  getCustomersLoadingText(): Observable<string | undefined> {
    return this.store.select(fromCustomers.selectCustomersLoadingText);
  }

  getCustomers(): Observable<Group[]> {
    return this.store.select(fromCustomers.selectAllGroups);
  }

  getPaginationState(): Observable<PaginationState> {
    return this.store.select(fromCustomers.selectCustomersPaginationState);
  }

  getAddCustomerParentGroup(): Observable<Partial<Group | undefined>> {
    return this.store.select(fromCustomers.selectAddCustomerParentGroupAttributes);
  }

  getGroupFilters(): Observable<GroupFilters> {
    return this.store.select(fromCustomers.selectGroupFilters);
  }

  getGroupSorting(): Observable<Sorting | undefined> {
    return this.store.select(fromCustomers.selectGroupSorting);
  }

  getCheckedCustomersForUpdate(): Observable<Group[]> {
    return this.store.select(fromCustomers.selectCheckedCustomersForUpdate);
  }

  getAllCustomersCheckedForUpdate(): Observable<boolean | undefined> {
    return this.store.select(fromCustomers.selectAllCustomersCheckedForUpdate);
  }
}
